import { ModuleStateEnum } from "./module-state.enum";

export type Description = {
  fr: string;
  en: string;
};

export enum SeverityCodeEnum {
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
}

export enum CodeEnum {
  LOW_BATTERY = "LOW_BATTERY",
  MOTOR_1_CONTROL_ERROR = "MOTOR_1_CONTROL_ERROR",
  MOTOR_1_MECHANICAL_TIMEOUT_ERROR = "MOTOR_1_MECHANICAL_TIMEOUT_ERROR",
  MOTOR_2_CONTROL_ERROR = "MOTOR_2_CONTROL_ERROR",
  MOTOR_2_MECHANICAL_TIMEOUT_ERROR = "MOTOR_2_MECHANICAL_TIMEOUT_ERROR",
  GAUGE_ERROR = "GAUGE_ERROR",
  ACCELEROMETER_ERROR = "ACCELEROMETER_ERROR",
  TEMPERATURE_TOO_HIGH = "TEMPERATURE_TOO_HIGH",
}
export type MachineError = {
  code: CodeEnum;
  label: Description;
  severity: Description;
  severityCode: SeverityCodeEnum;
  category: Description;
  doc: Description;
};

export enum ApplicationErrorCodeEnum {
  COMMUNICATION_TIMEOUT = "APP_COMMUNICATION_TIMEOUT",
  MAX_RETRY_COUNT_REACHED = "APP_MAX_RETRY_COUNT_REACHED",
}

export enum ApplicationErrorSeverityCodeEnum {
  CRITICAL = "CRITICAL",
}

export enum ApplicationErrorCategoryCodeEnum {
  COMMUNICATION_TIMEOUT = "APP_COMMUNICATION_TIMEOUT",
}

export type ApplicationError = {
  code: ApplicationErrorCodeEnum;
  severityCode: ApplicationErrorSeverityCodeEnum;
  categoryCode: ApplicationErrorCategoryCodeEnum;

  label: Description;
  severity: Description;
  category: Description;
  doc: Description;
};

export type ModuleTrackingView = {
  createdAt: string;
  moduleAddress: string;
  machineState: ModuleStateEnum;
  machineErrors: MachineError[];
  applicationErrors: ApplicationError[];
  stateOfCharge?: number;
};
